import { INaePdf } from "@newageerp/nae-react-ui/dist/interfaces";
export const NaeSPdfs: INaePdf[] = []